import { render } from "./CompanyPillars.vue?vue&type=template&id=65fabf75&scoped=true"
import script from "./CompanyPillars.vue?vue&type=script&lang=js"
export * from "./CompanyPillars.vue?vue&type=script&lang=js"

import "./CompanyPillars.vue?vue&type=style&index=0&id=65fabf75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fabf75"]])

export default __exports__